import { RTCSessionFacade } from '@/entities/webrtc'

import { ContactStatuses } from '@/shared/contact-status'
import { Contact } from '@/shared/types/api'

export type ContactStatusGetter = (c: Contact) => ContactStatuses | undefined

export function byFavorite (a: Contact, b: Contact): number {
  const isAFavorite = Boolean(a.isFavorite)
  const isBFavorite = Boolean(b.isFavorite)

  if (isAFavorite === isBFavorite) {
    return 0
  }

  return isAFavorite ? -1 : 1
}

export function byOnline (a: Contact, b: Contact, getStatus?: ContactStatusGetter): number {
  const statusA = getStatus?.(a)?.isOnline ?? false
  const statusB = getStatus?.(b)?.isOnline ?? false
  if (statusA && !statusB) return -1
  if (!statusA && statusB) return 1
  return 0
}

export function byLastSeen (a: Contact, b: Contact, getStatus?: ContactStatusGetter): number {
  const lastA = getStatus?.(a)?.lastSeen ?? 0
  const lastB = getStatus?.(b)?.lastSeen ?? 0
  if (lastA && lastB) {
    return lastB - lastA
  }
  return 0
}

export function byRole (a: string | undefined, b: string | undefined): number {
  if (a === 'Owner' || a === 'Moderator') {
    return -1
  } else if (b === 'Owner' || b === 'Moderator') {
    return 1
  } else {
    return 0
  }
}

export function byName (a: Contact, b: Contact): number {
  return a.name.localeCompare(b.name)
}

export function byFavoriteThenName (a: Contact, b: Contact): number {
  const favoriteCompare = byFavorite(a, b)
  if (favoriteCompare !== 0) {
    return favoriteCompare
  }

  return byName(a, b)
}

export function byActiveSession (a: Contact, b: Contact, sessions: Map<string, RTCSessionFacade>): number {
  for (const [, value] of sessions.entries()) {
    if (value.number === a.internalNumber) {
      return -1
    } else if (value.number === b.internalNumber) {
      return 1
    }
  }
  return 0
}
